var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[(_vm.is_current_user_fetched && _vm.$can('read', 'card-to-card-gateway'))?_c('div',[_c('manage-gateways')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }